module.exports = __webpack_public_path__ + "img/CS48Q.f28c84e8.jpg";